<template lang="pug">
.email-setup
  v-row(no-gutters)
    v-col.mr-4
      .title.mb-8
        .text-md.font-medium {{ $t('email_setup') }}
        .text-sm.neutral700--text.font-normal {{ $t('email_setup_description') }}
      .form
        v-form(ref="form")
          v-row(no-gutters)
            //- Subject line
            v-col.mb-8(cols="8")
              .text-md.font-medium {{ $t('email_setup_subject_line') }}
              v-text-field.text-md.font-normal.my-2.round-xl(v-model="subjectLine" :placeholder="$t('email_setup_subject_line_placeholder')" outlined hide-details="auto" :hint="$t('email_setup_subject_line_hint')" persistent-hint)
          v-row(no-gutters)
            //- Notification preview
            v-col.mb-8(cols="8")
              .text-md.font-medium {{ $t('email_setup_notification_preview_line') }}
              v-text-field.text-md.font-normal.my-2.round-xl(v-model="notificationPreviewLine" :placeholder="$t('email_setup_notification_preview_line_placeholder')" outlined hide-details="auto" :hint="$t('email_setup_notification_preview_line_hint')" persistent-hint)
    //- Preview
    v-col(v-if="!isMobileScreen" cols="5")
      .sticky.mb-4
        email-setup-preview(:subjectLine="subjectLine" :notificationPreviewLine="notificationPreviewLine")
  //- Save
  div.d-flex
    v-spacer
    v-btn.button-md(color="info500" dark depressed :loading="isLoading" @click="saveData") {{ $t('save') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EmailSetupPreview from '@/components/review/settings/EmailSetupPreview.vue'

export default {
  name: 'EmailSetup',
  components: {
    EmailSetupPreview
  },
  data () {
    return {
      isLoading: false,
      subjectLine: null,
      notificationPreviewLine: null
    }
  },
  props: {
    fetchingData: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.mapData()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const data = {
        email_subject: this.subjectLine,
        email_preview_text: this.notificationPreviewLine
      }
      this.$axios.patch(`/reviews/${this.company.slug}`, data)
        .then(() => {
          this.$store.commit('review/setSettings', data)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    mapData() {
      this.subjectLine = this.fetchingData.email_subject
      this.notificationPreviewLine = this.fetchingData.email_preview_text
    },
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.no-padding-x {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.selected-button {
  background: #EEEEEE !important;
  border-radius: 16px;
}
::v-deep svg.v-icon.notranslate.v-data-table-header__icon {
  height: 8px !important;
  width: 8px !important;
  margin-left: 8px;
}
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.pre-wrap {
  white-space: pre-wrap;
}
.sticky {
  top: 1%;
  position: sticky;
}
</style>